import { Convert } from "@components/billing/Convert";
import { Subscribe } from "@components/billing/Subscribe";
import { Upgrade } from "@components/billing/Upgrade";
import { Route } from "react-router-dom";

export const useRenderBillingRoutes = () => (
    <>
        <Route path="/subscribe/:plan" element={<Subscribe />} />
        <Route path="/upgrade/:plan" element={<Upgrade />} />
        <Route path="/convert" element={<Convert />} />
    </>
);
